import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {EditorControlService} from '../../../../../../surface3d/src/lib/API/Public/editor-control.service';
import {DataExchangeService} from '../../../../../../surface3d/src/lib/API/Public/data-exchange.service';


@Injectable({
    providedIn: 'root'
})
export class ImageOverlayService {

    // get/set
    private _landmarksActive = false;

    constructor(private router: Router,
                private editorControlService: EditorControlService,
                private dataExchangeService: DataExchangeService) {
    }

    get zoom(): number {
        return this.dataExchangeService.image.zoom;
    }

    get opacity(): number {
        return this.dataExchangeService.image.opacity;
    }

    get move(): boolean {
        return this.dataExchangeService.image.dragEnabled;
    }

    get landmarksVisible(): boolean {
        return this.dataExchangeService.image.landmarksVisible;
    }

    set landmarksVisible(value: boolean) {
        this.dataExchangeService.image.landmarksVisible = value;
    }

    get landmarksActive(): boolean {
        return this._landmarksActive;
    }

    set landmarksActive(value: boolean) {
        this._landmarksActive = value;
    }

    /**
     * zooms into image
     */
    public changeZoom(value: number) {
        this.dataExchangeService.image.zoom = value;
    }

    /**
     * changes opacity of image
     */
    public changeOpacity(value: number) {
        this.dataExchangeService.image.opacity = value;
    }

    /**
     * removes the image
     */
    public deleteImage() {
        this.dataExchangeService.image.clear();
        this.editorControlService.ctrl.next('pan');
    }

    /**
     * enables dragging of image
     */
    public toggleImageDrag() {
        if (!this.move) {
            this.editorControlService.ctrl.next('dragImage');
        } else {
            this.editorControlService.ctrl.next('pan');
        }
    }

    /**
     * resets image to default positioning
     */
    public posResetImg() {
        this.dataExchangeService.image.reset();
    }

    /**
     * navigates to image wizard view
     */
    public openImageWizard() {
        this.editorControlService.ctrl.next('pan');
        this.router.navigate(['/imageWizard']);
        this._landmarksActive = true;
        this.landmarksVisible = true;
    }

    /**
     * rotate overlay image
     * @param direction
     */
    public rotate(direction: string) {
        this.dataExchangeService.image.rotate(direction, Math.PI / 2);
    }

    public realignLandmarks() {
        this.dataExchangeService.image.realignLandmarks();
        this.editorControlService.ctrl.next('pan');
    }
}
